import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon'; // Importa MatIconModule

import { BottomNavigationComponent } from './bottom-navigation.component';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'; // Importa FontAwesomeModule

import { MatBadgeModule } from '@angular/material/badge';
@NgModule({
  declarations: [BottomNavigationComponent],
  imports: [
            CommonModule, 
            MatToolbarModule,
            FontAwesomeModule, 
            MatIconModule, 
            MatBadgeModule
        ], 
  exports: [BottomNavigationComponent]
})
export class BottomNavigationModule {}
